const TRIPTEASE_ORIGIN = 'https://onboard.triptease.io';
export class TripteaseAdapter {
    provider = 'TRIPTEASE';
    isLoaded = false;
    load(integration, ctx) {
        if (typeof window === 'undefined' || this.isLoaded)
            return;
        const integrationId = integration.configuration.integrationId;
        if (typeof integrationId !== 'string' || integrationId.length === 0) {
            ctx.logger.warn('Triptease adapter: missing integrationId', {
                integrationId: integration.id,
            });
            return;
        }
        const script = document.createElement('script');
        script.src = `${TRIPTEASE_ORIGIN}/bootstrap.js?integrationId=${encodeURIComponent(integrationId)}`;
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.type = 'text/javascript';
        script.onerror = () => {
            this.isLoaded = false;
            ctx.logger.warn('Triptease adapter: script load failed', { integrationId: integration.id });
        };
        script.onload = () => {
            this.isLoaded = true;
        };
        document.body.appendChild(script);
    }
    track(event, _integration, _ctx) {
        if (typeof window === 'undefined' || !this.isLoaded)
            return;
        const triptease = window.triptease;
        if (typeof triptease?.track !== 'function')
            return;
        triptease.track(event.kind, buildPayload(event));
    }
}
function buildPayload(event) {
    const payload = {};
    for (const [key, value] of Object.entries(event)) {
        if (key !== 'kind' && value !== undefined) {
            payload[key] = value;
        }
    }
    return payload;
}
//# sourceMappingURL=triptease-adapter.js.map